import SvgQuestionMark from 'assets/pricing/question-mark.inline.svg';
import SvgCircleEmpty from 'assets/secure-financing/circle-empty.inline.svg';
import SvgCircleFull from 'assets/secure-financing/circle-full.inline.svg';
import SvgCircleHalf from 'assets/secure-financing/circle-half.inline.svg';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { css } from 'twin.macro';

export const cssHalfBlue = css`
  circle {
    stroke: #24BCFD;
  }
  path {
    fill: #24BCFD;
  }
`;

export const cssHalfRed = css`
	circle {
		stroke: #E91616;
	}
	path {
		fill: #E91616;
	}
`;

export default function LegendBox() {
	const { t } = useTranslation();

	return (
		<div style={{ maxWidth: '80rem' }} className='border-2 border-grey-E rounded-10 mt-20 xl:mx-auto bg-light'>
			<div className='sm:flex items-center py-15 px-20'>
				<SvgQuestionMark />

				<div className='sm:ml-20 mt-15 sm:mt-0'>
					<div className='flex items-center mb-05 sm:mb-10'>
						<span><SvgCircleEmpty stroke="#24BCFD" /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.1')}</p>
					</div>
					<div className='flex items-center mb-05 sm:mb-10'>
						<span><SvgCircleHalf css={[ cssHalfBlue ]} /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.2')}</p>
					</div>
					<div className='flex items-center mb-05 sm:mb-10'>
						<span><SvgCircleFull fill='#24BCFD' /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.3')}</p>
					</div>
					<div className='flex items-center mb-05 sm:mb-10'>
						<span><SvgCircleFull fill='#0A9E50' /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.4')}</p>
					</div>
					<div className='flex items-center mb-05 sm:mb-10'>
						<span><SvgCircleHalf css={[ cssHalfRed ]} /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.5')}</p>
					</div>
					<div className='flex items-center'>
						<span><SvgCircleFull fill='#E91616' /></span>
						<p className='leading-12 ml-07'>{t('pageFinancingForCompany.legend.6')}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
